export const PRICING_VARIATION_WEEKDAYS_ID = 'weekdays';
export const CUSTOMER_COMMISSION_PERCENTAGE = 20;
export const PROVIDER_COMMISSION_PERCENTAGE = 17;
export const CUSTOMER_COMMISSION_DISCOUNT_PERCENTAGE = 50;
export const PROVIDER_COMMISSION_DISCOUNT_PERCENTAGE = 40;
export const CHILDREN_DISCOUNT_PERCENTAGE = 50;
export const CUSTOMER_COMMISSION_DISCOUNT_SWIM_PLUS_LEVEL_ONE_PERCENTAGE = 50;
export const CUSTOMER_COMMISSION_DISCOUNT_SWIM_PLUS_LEVEL_TWO_PERCENTAGE = 75;
